var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('img',{staticClass:"mx-auto",staticStyle:{"width":"128px"},attrs:{"src":"/img/loader.svg","alt":"Cargando..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }